// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-app img {
    width: 180px;
    margin-bottom: 10px;
}

.opciones {
    margin-top: 15px;
    margin-bottom: 40px;
}
.logo-version {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

a {
    color: #ffff;
}
a:hover {
    color: #d3d3d3;
    text-decoration: underline;
}

ul {
    list-style: none;
    margin: 0;
}
li {
    margin-bottom: 10px;
}
footer {
    /* height: 16rem; */
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/appfooter/appfooter.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".logo-app img {\n    width: 180px;\n    margin-bottom: 10px;\n}\n\n.opciones {\n    margin-top: 15px;\n    margin-bottom: 40px;\n}\n.logo-version {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\na {\n    color: #ffff;\n}\na:hover {\n    color: #d3d3d3;\n    text-decoration: underline;\n}\n\nul {\n    list-style: none;\n    margin: 0;\n}\nli {\n    margin-bottom: 10px;\n}\nfooter {\n    /* height: 16rem; */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
